// Comandos do agregado Perda (Fase 5, ADR-0022) — a saída definitiva de Peça
// do Backlog. A tela mira uma linha de saldo concreta e registra; desfazer é
// excluir.

import type { Snapshot } from "../domain/snapshot.ts";
import { excluirPerda, registrarPerda, type DadosPerda } from "../domain/backlog.ts";
import { assertNunca } from "../lib/assert-nunca.ts";
import { comoObjeto, exigirData, exigirTexto, paraNumero, texto } from "./_forma.ts";
import type { ContextoComando } from "./lotes.ts";

export type ComandoPerda =
  | { tipo: "registrar"; dados: DadosPerda }
  | { tipo: "excluir"; id: string };

export function executarComandoPerda(
  snapshot: Snapshot,
  cmd: ComandoPerda,
  ctx: ContextoComando,
): Snapshot {
  switch (cmd.tipo) {
    case "registrar":
      return registrarPerda(snapshot, cmd.dados, ctx.hoje);
    case "excluir":
      return excluirPerda(snapshot, cmd.id);
    default:
      return assertNunca(cmd);
  }
}

function validarDados(valor: unknown): DadosPerda {
  const o = comoObjeto(valor, "Dados da perda");
  return {
    clienteId: exigirTexto(o.clienteId, "clienteId"),
    tipoId: exigirTexto(o.tipoId, "tipoId"),
    origemLoteId: o.origemLoteId == null ? null : exigirTexto(o.origemLoteId, "origemLoteId"),
    motivoOrigem: exigirTexto(o.motivoOrigem, "motivoOrigem"),
    motivo: texto(o.motivo),
    quantidade: paraNumero(o.quantidade),
    data: exigirData(o.data, "data"),
  };
}

export function validarComandoPerda(valor: unknown): ComandoPerda {
  const c = comoObjeto(valor, "Comando de perda");
  switch (c.tipo) {
    case "registrar":
      return { tipo: "registrar", dados: validarDados(c.dados) };
    case "excluir":
      return { tipo: "excluir", id: exigirTexto(c.id, "id") };
    default:
      throw new Error(`Tipo de comando de perda desconhecido: ${String(c.tipo)}.`);
  }
}
